// Environment is switched via .env.development / .env.production (CRA reads
// the matching file automatically based on `npm start` vs `npm run build`).
// Per-machine overrides go in .env.development.local (gitignored).
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
const DOMAIN = process.env.REACT_APP_APP_DOMAIN || "http://localhost:3000";

// WebRTC TURN relay (context/CallContext.js) — same physical server for both
// environments, but kept in .env rather than hardcoded so it can be rotated
// without a code change.
const TURN_SERVER = process.env.REACT_APP_TURN_SERVER || "turn.beramour.com:3478";
const TURN_USERNAME = process.env.REACT_APP_TURN_USERNAME || "webrtcatuta";
const TURN_CREDENTIAL = process.env.REACT_APP_TURN_CREDENTIAL || "webrtcatutapassword";

// wss:// in production (https base), ws:// in local dev (http base) — derived
// rather than a separate env var, so it can never drift from the API host.
const WS_BASE_URL = BASE_URL.replace(/^http/, "ws");

const Configs = {
  baseUrl: BASE_URL,
  domain: DOMAIN,
  wsUserUrl: `${WS_BASE_URL}/ws/user/`,
  turnServer: TURN_SERVER,
  turnUsername: TURN_USERNAME,
  turnCredential: TURN_CREDENTIAL,
  apiGetUserNameByAccountEp: `${BASE_URL}/myprofile/api-get-user-name-by-account/`,
  toggleProfilePhotoFlaggedEp: `${BASE_URL}/myprofile/api-toggle-profile-photo-flagged/`,
  togglePhotoFlaggedEp: `${BASE_URL}/myprofile/api-toggle-photo-flagged/`,
  profilePhotosEp: `${BASE_URL}/myprofile/api-profile-photos/`,
  allPhotosEp: `${BASE_URL}/myprofile/api-all-photos/`,
  paypalCreatePaymentEp: `${BASE_URL}/myprofile/paypal-create-payment/`,
  announcementsEp: `${BASE_URL}/myprofile/api-all-announcements/`,
  singlesUsersEp: `${BASE_URL}/myprofile/api-singles/`,
  logSupportEp: `${BASE_URL}/myprofile/api-log-support/`,
  profileCompletionStatusEp: `${BASE_URL}/myprofile/api-profile-completion-status/`,
  updateLastSeenEp: `${BASE_URL}/myprofile/api-update-last-seen/`,
  fewUserDetailsEp: `${BASE_URL}/myprofile/api-get-few-user-details/`,
  coreDataEp: `${BASE_URL}/myprofile/api-core-data/`,
  sendCodeEp: `${BASE_URL}/myprofile/api-resend-code/`,
  guestDataEp: `${BASE_URL}/myprofile/api-guest-data/`,
  loginEp: `${BASE_URL}/myprofile/api-custom-sign-in/`,
  countriesEp: `${BASE_URL}/myprofile/api-all-countries/`,
  countryAreasEp: `${BASE_URL}/myprofile/api-country-areas/`,
  myBlockedEp: `${BASE_URL}/myprofile/api-mobile-blocked/`,
  myAdmirersEp: `${BASE_URL}/myprofile/api-mobile-admirers/`,
  myFavoritesEp: `${BASE_URL}/myprofile/api-mobile-favorites/`,
  profilesEp: `${BASE_URL}/myprofile/mobile-home/`,
  searchResultsEp: `${BASE_URL}/myprofile/api-search-results/`,
  filterUsersEp: `${BASE_URL}/myprofile/api-filter-users/`,
  savePaymentDetails: `${BASE_URL}/myprofile/api-save-payment-details/`,
  referralLink: `${BASE_URL}/myprofile/page-register/`,
  myDownlinesEp: `${BASE_URL}/myprofile/api-get-downlines/`,
  affiliateSignupEp: `${BASE_URL}/myprofile/api-affiliate-sign-up/`,
  logoutEp: `${BASE_URL}/myprofile/api-logout/`,
  createStaffEp: `${BASE_URL}/myprofile/api-create-staff/`,
  signupEp: `${BASE_URL}/myprofile/api-sign-up/`,
  verifyEmailEp: `${BASE_URL}/myprofile/verify-email/`,
  messageDetailsEp: `${BASE_URL}/myprofile/api-mobile-message-details/`,
  //   fewUserDetailsEp: `${BASE_URL}/myprofile/api-few-user-details/`,
  userDetailsEp: `${BASE_URL}/myprofile/mobile-user-details/`,
  updatePaymentDetailsEp: `${BASE_URL}/myprofile/api-update-payment-details/`,
  deleteUserEp: `${BASE_URL}/myprofile/api-delete-user/`,
  markConversationAsReadEp: `${BASE_URL}/myprofile/api-mark-conversation-as-read/`,
  markAsReadEp: `${BASE_URL}/myprofile/api-mark-as-read/`,
  getPendingCallEp: `${BASE_URL}/myprofile/api-get-pending-call/`,
  declineCallEp: `${BASE_URL}/myprofile/api-decline-call/`,
  sendMessagesEp: `${BASE_URL}/myprofile/api-mobile-send-message/`,
  mutualConversationEp: `${BASE_URL}/myprofile/api-mutual-conversation/`,
  conversationsEp: `${BASE_URL}/myprofile/api-user-conversations/`,
  conversationMessagesEp: `${BASE_URL}/myprofile/api-conversation-messages/`,
  fetchMessagesEp: `${BASE_URL}/myprofile/api-mobile-messages/`,

  // The endpoint has been updated to use a hyphen
  apiGetUnreadCountEp: `${BASE_URL}/myprofile/api-get-unread-count/`,
  apiGetMessagesEp: `${BASE_URL}/myprofile/api-get-messages/`,

  // Validate photo endpoint
  validatePhotoEp: `${BASE_URL}/myprofile/validate-photo/`,

  downlinesSummaryEp: `${BASE_URL}/myprofile/api-get-downline-summary/`,
  blockUnblockEp: `${BASE_URL}/myprofile/api-block-unblock/`,
  likeUnlikeEp: `${BASE_URL}/myprofile/api-like-unlike/`,
  mutualLikesEp: `${BASE_URL}/myprofile/api-mutual-likes/`,
  favsBlockedEp: `${BASE_URL}/myprofile/api-mobile-favs-blocked/`,
  deleteAccountEp: `${BASE_URL}/myprofile/api-mobile-delete-account/`,
  toggleShowPhotosToAnonymousEp: `${BASE_URL}/myprofile/api-toggle-show-photos-to-anonymous/`,
  toggleHidePhotosFromCountrymatesEp: `${BASE_URL}/myprofile/api-toggle-hide-photos-from-countrymates/`,
  toggleShowHidePhotosEp: `${BASE_URL}/myprofile/api-toggle-hide-photos/`,
  toggleStatusEp: `${BASE_URL}/myprofile/api-toggle-status/`,
  activateDeactivateAccountEp: `${BASE_URL}/myprofile/api-toggle-active-inactive/`,
  updateFcmTokenEp: `${BASE_URL}/myprofile/api-update-fcm-token/`,
  updateInterestsEp: `${BASE_URL}/myprofile/api-update-interests/`,
  updateAboutMeEp: `${BASE_URL}/myprofile/api-update-about-me/`,
  updateLocationEp: `${BASE_URL}/myprofile/api-update-location/`,
  updateSocialMediaEp: `${BASE_URL}/myprofile/api-update-social-media/`,
  uploadPhotoEp: `${BASE_URL}/myprofile/upload-photo/`,
  uploadProfilePhotoEp: `${BASE_URL}/myprofile/upload-profile-photo/`,
  setProfilePhotoFromGalleryEp: `${BASE_URL}/myprofile/api-set-profile-photo-from-gallery/`,
  deletePhotoEp: `${BASE_URL}/myprofile/api-delete-photo/`,
  changePasswordEp: `${BASE_URL}/myprofile/change-password/`,
  sendPasswordResetCodeEp: `${BASE_URL}/myprofile/send-password-reset-code/`,
  interestsEp: `${BASE_URL}/myprofile/api-interests/`,
  resetPasswordEp: `${BASE_URL}/myprofile/reset-password/`,
  fcmServerKey: "",
  sendFcmMessageEp: "https://fcm.googleapis.com/fcm/send",

  // JWT Token Endpoints
  tokenObtainPairEp: `${BASE_URL}/myprofile/api/token/`,
  tokenRefreshEp: `${BASE_URL}/myprofile/api/token/refresh/`,

  // Web Push Notification Subscription Endpoint (NEW)
  subscribeToPushNotificationsEp: `${BASE_URL}/myprofile/api-subscribe-to-push-notifications/`,

  // Sentinel/asset URLs previously re-declared per-file
  noPhotoUrl: `${BASE_URL}/media/none`,
  flagCdnBaseUrl: "https://flagcdn.com/w40",
  supportUrl: "https://support.beramour.com/",
};

export default Configs;
